<template>
  <div class="articleBasicForm">
    <el-form-item label="文章标题" required>
      <el-input
        v-model="local.articleTitle"
        placeholder="必填：下发给 App 的文章标题，例如 Weekly fitness tips"
      />
    </el-form-item>
  </div>
</template>

<script>
import basicFormMixin from './basicFormMixin'

const EMPTY = () => ({
  articleTitle: '',
})

export default {
  name: 'ArticleBasicForm',
  mixins: [basicFormMixin],
  data() {
    return {
      local: EMPTY(),
    }
  },
  methods: {
    /** articleTitle 写入 jsonConfig.exta，随资源下发 App 作为文章标题 */
    buildExtaPayload() {
      return {
        articleTitle: String(this.local.articleTitle || '').trim(),
      }
    },
    loadFromExta(exta) {
      const data = exta || {}
      this.local = {
        articleTitle: data.articleTitle || '',
      }
    },
    reset() {
      this.local = EMPTY()
    },
    validate() {
      if (!String(this.local.articleTitle || '').trim()) {
        return Promise.reject('请填写文章标题')
      }
      return Promise.resolve()
    },
    captureSnapshot() {
      return { ...this.local }
    },
  },
}
</script>
